import { VStack } from '@chakra-ui/react'
import { NodeProps } from '@xyflow/react'
import React from 'react'

import { SoundClipNodeData } from '../../converters/shared/reactFlowTypes'
import { useSwitchboardT } from '../../types'
import { text } from '../../utils/text'
import { SoundClipSelector } from '../core/SoundClipSelector'
import { BaseNode, nodePropsAreEqual } from './BaseNode'
import { useSoundClipNode } from './hooks/useSoundClipNode'

export interface SoundClipNodeProps extends NodeProps {
  onDelete?: () => void
  onDeleteNode?: (nodeId: string) => void
  showDeleteButton?: boolean
  // Note: soundClips is provided via Jotai atoms (soundClipsAtom)
  // Use useSwitchboardDataAtoms hook in the consuming app to set atoms
}

const SoundClipNodeComponent: React.FC<SoundClipNodeProps> = ({
  id,
  data,
  onDelete,
  onDeleteNode,
  showDeleteButton,
}) => {
  const nodeData = data as SoundClipNodeData & Record<string, unknown>
  const { currentSoundClipId, handleSoundClipChange, hasData } =
    useSoundClipNode(id, nodeData)
  const t = useSwitchboardT()

  return (
    <BaseNode
      label={text(t, 'switchboard.nodeLabels.sound_clip', 'SOUND CLIP')}
      showPlaceholder={!hasData}
      onDelete={onDelete}
      onDeleteNode={onDeleteNode}
      id={id}
      showDeleteButton={showDeleteButton}
    >
      <VStack align="stretch" gap={2}>
        <SoundClipSelector
          value={currentSoundClipId}
          onChange={handleSoundClipChange}
          placeholder={text(
            t,
            'switchboard.core.selectSoundClip',
            'Select sound clip...',
          )}
        />
      </VStack>
    </BaseNode>
  )
}

export const SoundClipNode = React.memo(
  SoundClipNodeComponent,
  nodePropsAreEqual,
)
